<template>
    <div>
        <div v-if="dailyScrum">
            <div class="mb-2 pa-2 text-xs-left" v-for="(item, index) in dailyScrum.items" :key="`scrum-item-${index}`">
                <h3 class="question-card-title mb-2">{{item.question}}</h3>

                <div v-if="item.rankType == 0">
                    <div class="answer"><div v-html="item.answer"></div></div>
                </div>

                <div v-else-if="item.rankType == 1">
                    <span class="item tl-red" :class="setClass(item, 0)" @click="setAnswer(item, 0)">
                        <v-icon>mdi-circle</v-icon>
                    </span>
                    <span class="item tl-amber" :class="setClass(item, 1)" @click="setAnswer(item, 1)">
                        <v-icon>mdi-circle</v-icon>
                    </span>
                    <span class="item tl-green" :class="setClass(item, 2)" @click="setAnswer(item, 2)">
                        <v-icon>mdi-circle</v-icon>
                    </span>
                </div>

                <div v-else-if="item.rankType == 2">
                    <span class="item very-sad is-not-selected" :class="setClass(item, 0)" @click="setAnswer(item, 0)">
                        <v-icon>mood_bad</v-icon>
                    </span>
                    <span class="item sad is-not-selected" :class="setClass(item, 1)" @click="setAnswer(item, 1)">
                        <v-icon>mdi-emoticon-sad-outline</v-icon>
                    </span>
                    <span class="item neutral is-not-selected" :class="setClass(item, 2)" @click="setAnswer(item, 2)">
                        <v-icon>mdi-emoticon-neutral-outline</v-icon>
                    </span>
                    <span class="item happy is-not-selected" :class="setClass(item, 3)" @click="setAnswer(item, 3)">
                        <v-icon>mdi-emoticon-happy-outline</v-icon>
                    </span>
                    <span class="item very-happy is-not-selected" :class="setClass(item, 4)" @click="setAnswer(item, 4)">
                        <v-icon>mood</v-icon>
                    </span>
                </div>

                <div v-else>
                    <span class="not-answered-text">Uh oh! Couldn't get this answer.</span>
                </div>
            </div>
        </div>
        <div v-else class="text-xs-left">
            N/A
        </div>

    </div>
</template>

<script>
    export default {
    	props: {
    		dailyScrum: {
    			required: true
    		}
    	},
    	data() {
    		return {};
    	}
    };
</script>

<style scoped>
    .question-card-title {
    	font-weight: 500;
    }
    .answer {
    	color: rgba(0, 0, 0, 0.54);
        white-space: pre-line;
    }
</style>
